import {Component} from '@angular/core';
import {ShareddataService} from './shared/services/shareddata.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private titleservice: Title,
    private shareddata: ShareddataService,
  ) {
    this.shareddata.mandanttitle$.subscribe((data) => {
      this.titleservice.setTitle(data);
    });
  }

}
